module.exports = __webpack_public_path__ + "img/logo.3e34b269.png";